function Video({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '20'} height=${(dimensions * 4) / 5 || '16'} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 3.5V12.5L14.5 8L7.5 3.5Z" fill=${`"${col}"`}/>
    <path d="M18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14.01H2V1.99H18V14.01Z" fill=${`"${col}"`}/>
  </svg>
  `;

  return baseXml;
}

export default Video;
